module.exports = __webpack_public_path__ + "img/how_it_works_3.4a82c843.png";